module.exports = __webpack_public_path__ + "d60cca171ac6f23915ce857a0e8c764c.png";